import { LineElements } from "../elements/LineElements";
import { Sampler2D } from "../image/Sampler2D";
import { BitmapImage2D } from "../image/BitmapImage2D";
import { BitmapImageCube } from "../image/BitmapImageCube";
import { BasicMaterial } from "../materials/BasicMaterial";
import { Single2DTexture } from "../textures/Single2DTexture";
import { SingleCubeTexture } from "../textures/SingleCubeTexture";
import { Shape } from "../base/Shape";
var DefaultMaterialManager = (function () {
    function DefaultMaterialManager() {
    }
    DefaultMaterialManager.getDefaultMaterial = function (renderable) {
        if (renderable === void 0) { renderable = null; }
        if (renderable != null && renderable.isAsset(Shape) && renderable.elements.isAsset(LineElements)) {
            if (!DefaultMaterialManager._defaultColorMaterial)
                DefaultMaterialManager.createDefaultColorMaterial();
            return DefaultMaterialManager._defaultColorMaterial;
        }
        if (renderable != null && renderable.assetType == "[asset Skybox]") {
            if (!DefaultMaterialManager._defaultCubeTextureMaterial)
                DefaultMaterialManager.createDefaultCubeTextureMaterial();
            return DefaultMaterialManager._defaultCubeTextureMaterial;
        }
        if (!DefaultMaterialManager._defaultTextureMaterial)
            DefaultMaterialManager.createDefaultTextureMaterial();
        return DefaultMaterialManager._defaultTextureMaterial;
    };
    DefaultMaterialManager.getDefaultTexture = function (renderable) {
        if (renderable === void 0) { renderable = null; }
        if (renderable != null && renderable.assetType == "[asset Skybox]") {
            if (!DefaultMaterialManager._defaultCubeTexture)
                DefaultMaterialManager.createDefaultCubeTexture();
            return DefaultMaterialManager._defaultCubeTexture;
        }
        if (!DefaultMaterialManager._defaultTexture)
            DefaultMaterialManager.createDefaultTexture();
        return DefaultMaterialManager._defaultTexture;
    };
    DefaultMaterialManager.getDefaultImage2D = function () {
        if (!DefaultMaterialManager._defaultBitmapImage2D)
            DefaultMaterialManager.createDefaultImage2D();
        return DefaultMaterialManager._defaultBitmapImage2D;
    };
    DefaultMaterialManager.getDefaultImageCube = function () {
        if (!DefaultMaterialManager._defaultBitmapImageCube)
            DefaultMaterialManager.createDefaultImageCube();
        return DefaultMaterialManager._defaultBitmapImageCube;
    };
    DefaultMaterialManager.getDefaultSampler = function () {
        if (!DefaultMaterialManager._defaultSampler2D)
            DefaultMaterialManager.createDefaultSampler2D();
        return DefaultMaterialManager._defaultSampler2D;
    };
    DefaultMaterialManager.createDefaultTexture = function () {
        DefaultMaterialManager._defaultTexture = new Single2DTexture();
        DefaultMaterialManager._defaultTexture.name = "defaultTexture";
    };
    DefaultMaterialManager.createDefaultCubeTexture = function () {
        DefaultMaterialManager._defaultCubeTexture = new SingleCubeTexture();
        DefaultMaterialManager._defaultCubeTexture.name = "defaultCubeTexture";
    };
    DefaultMaterialManager.createDefaultImageCube = function () {
        if (!DefaultMaterialManager._defaultBitmapImage2D)
            DefaultMaterialManager.createDefaultImage2D();
        var b = new BitmapImageCube(DefaultMaterialManager._defaultBitmapImage2D.width);
        for (var i = 0; i < 6; i++)
            b.draw(i, DefaultMaterialManager._defaultBitmapImage2D);
        DefaultMaterialManager._defaultBitmapImageCube = b;
    };
    DefaultMaterialManager.createDefaultImage2D = function () {
        var b = new BitmapImage2D(8, 8, false, 0x000000);
        //create chekerboard
        var i, j;
        for (i = 0; i < 8; i++)
            for (j = 0; j < 8; j++)
                if ((j & 1) ^ (i & 1))
                    b.setPixel(i, j, 0XFFFFFF);
        DefaultMaterialManager._defaultBitmapImage2D = b;
    };
    DefaultMaterialManager.createDefaultTextureMaterial = function () {
        if (!DefaultMaterialManager._defaultTexture)
            DefaultMaterialManager.createDefaultTexture();
        DefaultMaterialManager._defaultTextureMaterial = new BasicMaterial();
        DefaultMaterialManager._defaultTextureMaterial.texture = DefaultMaterialManager._defaultTexture;
        DefaultMaterialManager._defaultTextureMaterial.name = "defaultTextureMaterial";
    };
    DefaultMaterialManager.createDefaultCubeTextureMaterial = function () {
        if (!DefaultMaterialManager._defaultCubeTexture)
            DefaultMaterialManager.createDefaultCubeTexture();
        DefaultMaterialManager._defaultCubeTextureMaterial = new BasicMaterial();
        DefaultMaterialManager._defaultCubeTextureMaterial.texture = DefaultMaterialManager._defaultCubeTexture;
        DefaultMaterialManager._defaultCubeTextureMaterial.name = "defaultCubeTextureMaterial";
    };
    DefaultMaterialManager.createDefaultColorMaterial = function () {
        DefaultMaterialManager._defaultColorMaterial = new BasicMaterial(0xFFFFFF);
        DefaultMaterialManager._defaultColorMaterial.name = "defaultColorMaterial";
    };
    DefaultMaterialManager.createDefaultSampler2D = function () {
        DefaultMaterialManager._defaultSampler2D = new Sampler2D();
    };
    return DefaultMaterialManager;
}());
export { DefaultMaterialManager };



// WEBPACK FOOTER //
// ../dist/lib/managers/DefaultMaterialManager.js